/**
 * Created by h.nanev on 6/30/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import ResponsiveUtils from "@tinqin/tinqin-utils/src/responsiveness/index";
import documentedProps from "./documentation/TooltipDocumentedProps";
import DeviceUtils from "@tinqin/tinqin-utils/src/devices";

import("./Tooltip.less");

var hasListener = false;

export default class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.anchor = React.createRef();
        this.tooltip = React.createRef();
        this.state = { active: props.active || false };
    }

    componentDidUpdate() {
        if (this.state.active) {
            this.showTooltip();
        } else {
            this.hideTooltip();
        }
    }

    componentDidMount() {
        if (this.state.active) {
            this.showTooltip();
        }
    }

    showTooltip() {
        if (!this.props.value) return;

        if (!hasListener) {
            document.addEventListener("scroll", this._showTooltip, true);
            hasListener = true;
        }
        let anchor = this.anchor.current;
        let tooltip = this.tooltip.current;

        if (this.props.maxWidth) {
            Object.assign(tooltip.style, {
                maxWidth: this.props.maxWidth
            });
        }

        // let initialDisplayOfParent = window.getComputedStyle(anchor.parentNode).display;
        // anchor.parentNode.style.display = "block";

        if (anchor && tooltip) {
            let anchorRect = ResponsiveUtils.getBoundingClientRectObject(anchor);
            let anchorHeight = anchorRect.height;
            let anchorWidth = anchorRect.width;
            let anchorTop = anchorRect.top;
            if (DeviceUtils.isIOSMobileDevice()) {
                anchorTop = anchorRect.top + window.scrollY;
            }
            let anchorLeft = anchorRect.left;
            let anchorBottom = anchorTop + anchorHeight;
            let anchorRight = anchorLeft + anchorWidth;
            let anchorCenterX = anchorLeft + anchorWidth / 2;

            let contentRect = ResponsiveUtils.getBoundingClientRectObject(tooltip);
            let tooltipHeight = contentRect.height;
            let tooltipWidth = contentRect.width;

            let {
                outOfBoundsHalfTop,
                outOfBoundsHalfBottom,
                outOfBoundsHalfRight,
                outOfBoundsHalfLeft
            } = ResponsiveUtils.isOutOfWindowViewport(anchorRect, {
                height: tooltipHeight,
                width: tooltipWidth
            });

            let posTop = {
                top: anchorTop - tooltipHeight + "px",
                left: anchorCenterX - tooltipWidth / 2 + "px"
            };
            let posTopRight = {
                top: anchorTop - tooltipHeight + "px",
                left: anchorLeft + "px"
            };
            let posTopLeft = {
                top: anchorTop - tooltipHeight + "px",
                left: anchorRight - tooltipWidth + "px"
            };
            let posBottom = {
                top: anchorBottom + "px",
                left: anchorCenterX - tooltipWidth / 2 + "px"
            };
            let posBottomRight = {
                top: anchorBottom + "px",
                left: anchorLeft + "px"
            };
            let posBottomLeft = {
                top: anchorBottom + "px",
                left: anchorRight - tooltipWidth + "px"
            };

            let position;
            let extraClasses = this.props.extraClasses || "";
            let className = extraClasses + " tq-tooltip";
            let zIndex;

            switch (this.props.preferredPosition) {
                case "bottom":
                    position = posBottom;
                    break;
                default:
                    position = posTop;
                    break;
            }

            if (this._isInModal(anchor)) {
                zIndex = 108;
            } else {
                zIndex = 91;
            }

            if (this.props.preferredPosition === "bottom") {
                if (outOfBoundsHalfBottom && outOfBoundsHalfLeft) {
                    position = posTopRight;
                    className += " tq-top-left-pos";
                } else if (outOfBoundsHalfBottom && outOfBoundsHalfRight) {
                    position = posTopLeft;
                    className += " tq-top-right-pos";
                } else if (outOfBoundsHalfBottom) {
                    position = posTop;
                    className += " tq-top-pos";
                } else if (outOfBoundsHalfLeft) {
                    position = posBottomRight;
                    className += " tq-bottom-left-pos";
                } else if (outOfBoundsHalfRight) {
                    position = posBottomLeft;
                    className += " tq-bottom-right-pos";
                } else {
                    className += " tq-bottom-pos";
                }
            } else {
                //default case "top":
                if (outOfBoundsHalfTop && outOfBoundsHalfLeft) {
                    position = posBottomRight;
                    className += " tq-bottom-left-pos";
                } else if (outOfBoundsHalfTop && outOfBoundsHalfRight) {
                    position = posBottomLeft;
                    className += " tq-bottom-right-pos";
                } else if (outOfBoundsHalfTop) {
                    position = posBottom;
                    className += " tq-bottom-pos";
                } else if (outOfBoundsHalfLeft) {
                    position = posTopRight;
                    className += " tq-top-left-pos";
                } else if (outOfBoundsHalfRight) {
                    position = posTopLeft;
                    className += " tq-top-right-pos";
                }
            }

            let tooltipPosition = "fixed";
            if (DeviceUtils.isIOSMobileDevice()) {
                tooltipPosition = "absolute";
            }

            tooltip.className = className;
            Object.assign(tooltip.style, position);
            Object.assign(tooltip.style, {
                position: tooltipPosition,
                bottom: "auto",
                WebkitTransition: "opacity 0.25s ease-out",
                transition: "opacity 0.25s ease-out",
                transform: "none",
                zIndex: zIndex,
                opacity: 1
            });

            // There is a bug in Chrome that brakes position fixed when using -webkit-transform.
            // http://stackoverflow.com/questions/2637058/positions-fixed-doesnt-work-when-using-webkit-transform
            anchor.style.WebkitTransform = "none";
        }
    }

    hideTooltip() {
        if (!this.props.value) return;

        let tooltip = this.tooltip.current;
        if (hasListener) {
            document.removeEventListener("scroll", this._showTooltip, true);
            hasListener = false;
        }
        if (tooltip) {
            Object.assign(tooltip.style, {
                opacity: 0
            });
        }
    }

    _isInModal(child) {
        var node = child.parentNode;
        while (node !== null) {
            if ((" " + node.className + " ").indexOf(" tq-modal-container ") > -1) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    onMouseEnter() {
        this.setState({ active: true });
    }

    onMouseLeave() {
        this.setState({ active: false });
    }

    render() {
        let containerClass = this.props.containerClass || "tq-tooltip-container";
        let extraClasses = this.props.extraClasses || "";
        let valueClass = extraClasses + " tq-tooltip";
        return (
            <div
                ref={this.anchor}
                className={containerClass}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {this.props.children}
                {this.props.value &&
                    this.state.active &&
                    ReactDOM.createPortal(
                        <div className={this.props.placeholderClass}>
                            <div ref={this.tooltip} className={valueClass}>
                                {this.props.value}
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
        );
    }
}

Tooltip.displayName = "Tooltip";

Tooltip.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    extraClasses: PropTypes.string,
    maxWidth: PropTypes.string,
    containerClass: PropTypes.string,
    placeholderClass: PropTypes.string,
    preferredPosition: PropTypes.string
};

Tooltip.documentedProps = documentedProps;
